const atcButtons = document.querySelectorAll(".kit-product__atc");
const priceBlock = document.querySelector('.product__block.kit-summary__price');

let bundleProductArr = [];

function init() {
    atcButtons.forEach(btn => {
        btn.addEventListener("click", () => {
            const block = btn.closest('[data-product-block]');
            if (!block?.dataset.productInfo) return;

            const productInfo = JSON.parse(block.dataset.productInfo);

            if (bundleProductArr.some(p => p.id === productInfo.variantId)) return;

            bundleProductArr.push({
                id: productInfo.variantId,
                image: productInfo.productImage,
                price: Number(productInfo.productPrice),
                title: productInfo.title,
                quantity: 1,
                properties: productInfo.properties
            });

            updateProductStatus();
            updateKitDiscount();
            renderPopup();
            updateBundleCTA();
        });
    });
}

init();

async function addKitsToCart() {
    if (!bundleProductArr.length) return;

    const formData = {
        items: bundleProductArr.map(item => ({
            id: item.id,
            quantity: item.quantity,
            ...(item.properties && { properties: item.properties })
        }))
    };

    try {
        const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        });

        if (!res.ok) throw new Error('Add to cart failed');

        const result = await res.json();

        await window.cart.getCart();

        window.cart.openCartDrawer();

    } catch (error) {
        console.error('Bundle add to cart error:', error);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    document
        .querySelectorAll('.product__submit__add-custom-bundle')
        .forEach(btn => {
            btn.addEventListener('click', addKitsToCart);
        });
});

function getItemCount() {
    return bundleProductArr.reduce((sum, p) => sum + p.quantity, 0);
}

function updateProductStatus() {
    atcButtons.forEach(btn => {
        const productBlock = btn.closest('[data-product-block]');
        if (!productBlock) return;

        const id = Number(productBlock.dataset.id);
        const exists = bundleProductArr.some(p => p.id === id);

        productBlock.classList.toggle('added', exists);
    });
}

function updateBundleCTA() {
    const itemCount = getItemCount();
    const isValid = itemCount > 0;

    document.querySelectorAll('.product__submit__add-custom-bundle').forEach(btn => {
        let warning = btn.nextElementSibling;
        if (!warning || !warning.classList.contains('bundle-warning')) {
            warning = document.createElement('span');
            warning.className = 'bundle-warning';
            warning.textContent = 'Please add at least 1 item to continue';
            warning.hidden = true;
            btn.after(warning);
        }

        btn.disabled = !isValid;
        warning.hidden = isValid;
    });
}

function renderPopup() {
    const qtyEl = document.querySelector(".kit-summary__items");
    const popupEl = document.querySelector(".kits-show-all__popup");
    const overlayEl = document.querySelector(".kits-popup__overlay");
    const itemsWrapperEl = popupEl?.querySelector(".product-list");

    if (!qtyEl || !popupEl || !overlayEl || !itemsWrapperEl) return;

    qtyEl.classList.toggle("has-items", bundleProductArr.length > 0);

    itemsWrapperEl.innerHTML = bundleProductArr.map(item => `
    <div class="kits-bundle-item">
      <img src="${item.image}" alt="">
      <p class="kit-item__title">${item.title}</p>
      <div class="kit-item__remove" >
      <p>Qty:${item.quantity}</p>
      <button class="remove-btn" data-id="${item.id}">
         <svg class="remove-icon" width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="variant_icon_b1cfee51"><path d="M5 1.99388C5 0.892691 5.89543 0 7 0C8.10457 0 9 0.892691 9 1.99388H13C13.5523 1.99388 14 2.44023 14 2.99082C14 3.54142 13.5523 3.98776 13 3.98776H1C0.447716 3.98776 0 3.54142 0 2.99082C0 2.44023 0.447715 1.99388 1 1.99388H5Z" fill="currentColor"></path><path d="M2 12.5076V6H4V12.5076C4 12.7829 4.22386 13.0061 4.5 13.0061H6V6H8L8 13.0061H9.5C9.77614 13.0061 10 12.7829 10 12.5076V6H12V12.5076C12 13.8841 10.8807 15 9.5 15H4.5C3.11929 15 2 13.8841 2 12.5076Z" fill="currentColor"></path></svg>
      </button>
      </div>
    </div>
  `).join("");
}

document.addEventListener("click", e => {
    const qtyBtn = e.target.closest(".kit-summary__items");
    const removeBtn = e.target.closest(".kit-item__remove .remove-btn");
    const overlayEl = document.querySelector(".kits-popup__overlay");
    const popupEl = document.querySelector(".kits-show-all__popup");

    if (qtyBtn && bundleProductArr.length) {
        popupEl?.classList.add("popup-active");
        overlayEl?.classList.add("popup-active");
        document.body.classList.add("popup-active");
    }

    if (e.target === overlayEl || e.target.closest(".kits-popup__close")) {
        popupEl.classList.remove("popup-active");
        overlayEl.classList.remove("popup-active");
        document.body.classList.remove("popup-active");
    }

    if (removeBtn) {
        const id = Number(removeBtn.dataset.id);
        bundleProductArr = bundleProductArr.filter(item => item.id !== id);

        updateProductStatus();
        updateKitDiscount();
        renderPopup();
        updateBundleCTA();
    }
});

function calculatePrice(discountPercent) {
  const total =
    bundleProductArr.reduce((sum, p) => sum + p.price * p.quantity, 0) / 100;

  const discountedTotal = Math.max(
    total - (total * discountPercent) / 100,
    0
  );

  const discountAmount = total - discountedTotal;

  document.querySelectorAll(".kit-summary__price .total").forEach(el => {
    el.innerText = (el.dataset.symbol || '') + total.toFixed(2);
  });

  document.querySelectorAll(".kit-summary__price .total-discounted").forEach(el => {
    el.innerText = discountedTotal.toFixed(2);
  });

  document.querySelectorAll(".kit-summary__price .discount-percentage").forEach(el => {
    el.innerText = discountAmount.toFixed(2) + " SAVING";
  });

  priceBlock?.classList.toggle("is-active", bundleProductArr.length > 0);
}

function updateKitDiscount() {
    const itemCount = getItemCount();
    const kits = document.querySelectorAll('.kit-tag');
    let appliedDiscount = 0;

    kits.forEach((kit, index) => {
        const min = Number(kit.dataset.productCount);
        const max = kits[index + 1] ?
            Number(kits[index + 1].dataset.productCount) :
            Infinity;

        const active = itemCount >= min && itemCount < max;
        kit.classList.toggle('is-active', active);

        if (active) appliedDiscount = Number(kit.dataset.discount);
    });

    calculatePrice(appliedDiscount);
    updateBundleCTA();
}

updateKitDiscount();

document.addEventListener('click', e => {
    const btn = e.target.closest('.kit-product .quantity button');
    if (!btn) return;

    const productBlock = btn.closest('[data-product-block]');
    if (!productBlock) return;

    const input = productBlock.querySelector('.input-box');
    const variantId = Number(productBlock.dataset.id);

    let qty = Number(input.value);
    const max = Number(input.max) || 50;

    if (btn.classList.contains('plus') && qty < max) qty++;
    if (btn.classList.contains('minus')) qty--;

    if (qty <= 0) {
        bundleProductArr = bundleProductArr.filter(p => p.id !== variantId);
    } else {
        const item = bundleProductArr.find(p => p.id === variantId);
        if (item) item.quantity = qty;
    }

    input.value = Math.max(qty, 1);

    updateProductStatus();
    updateKitDiscount();
    renderPopup();
});

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.kit-products__list[data-bundle-slider]').forEach(slider => {
        new Flickity(slider, {
            cellSelector: '[data-slide]',
            cellAlign: 'left',
            contain: true,
            prevNextButtons: true,
            pageDots: false,
            adaptiveHeight: true
        });
    });
});

